import useMutation from "src/hooks/useMutation";

function useOrderCreate() {
  return useMutation({
    path: "/api/v1/orders",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: [`/api/v1/orders`, `/api/v1/orders/count`],
      shouldRevalidate: true,
    },
  });
}

export default useOrderCreate;
